import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import dynamic from 'next/dynamic';

import Flex from 'shopper/components/Flex';

import { useTopbar } from 'providers/TopbarProvider';

const OfferPagesTabNav = dynamic(() => import('./OfferPagesTabNav'));
const TopbarSearch = dynamic(() => import('../TopbarSearch'), { ssr: false });

const getBottomSize = ({
  isSearchActive,
  isTopbarBottomActive,
  topbarBottomHeight,
  topbarSearchHeight,
}) => {
  if (!isTopbarBottomActive) {
    if (isSearchActive) {
      return topbarSearchHeight * -1;
    }

    return 0;
  }

  if (isTopbarBottomActive && isSearchActive) {
    return (topbarSearchHeight + topbarBottomHeight) * -1;
  }

  if (isTopbarBottomActive) {
    return topbarBottomHeight * -1;
  }

  if (isSearchActive) {
    return topbarSearchHeight * -1;
  }

  return null;
};

const StyledTopbarBottom = styled(Flex)`
  ${({ isTopbarBottomActive, theme }) => css`
    box-shadow: ${isTopbarBottomActive ? null : theme.shadows.size2};
    transition: bottom ease-in 0.3s;
    will-change: bottom;
  `}
`;

const TopbarBottom = () => {
  const theme = useTheme();
  const {
    topbarMobile: {
      constants: { topbarBottomHeight, topbarSearchHeight },
      isSearchActive,
      isTopbarBottomActive,
    },
  } = useTopbar();

  if (!isSearchActive && !isTopbarBottomActive) {
    return null;
  }

  return (
    <StyledTopbarBottom
      position="absolute"
      flexDirection="column"
      borderColor={theme.app.topbar.borderBg}
      bottom={getBottomSize({
        isSearchActive,
        isTopbarBottomActive,
        topbarBottomHeight,
        topbarSearchHeight,
      })}
      full
    >
      {isSearchActive && (
        <Flex bg={theme.app.topbar.background} py={2} px={4}>
          <TopbarSearch id="mobile_topbar_page" width="100%" />
        </Flex>
      )}
      {isTopbarBottomActive && <OfferPagesTabNav />}
    </StyledTopbarBottom>
  );
};

export default TopbarBottom;
